import { Component, input } from "@angular/core";
import { BrandingState } from "../branding/store/branding.state";
import { LEGAL_DATA_SECURITY, LEGAL_IMPRINT } from "../../routes";
import { RouterLink } from "@angular/router";

import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-footer-legal-links",
    templateUrl: "./footer-legal-links.component.html",
    styleUrls: ["./footer-legal-links.component.scss"],
    imports: [
    RouterLink,
    TranslatePipe
],
})
export class FooterLegalLinksComponent {
    readonly brandingData = input<BrandingState | undefined>(undefined);
    readonly currentYear: number = new Date().getFullYear();
    readonly dataSecurityRoute = LEGAL_DATA_SECURITY;
    readonly imprintRoute = LEGAL_IMPRINT;
}
